var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75H4.5C4.10218 3.75 3.72064 3.90804 3.43934 4.18934C3.15804 4.47064 3 4.85218 3 5.25V10.7597C3 19.1606 10.1081 21.9478 11.5312 22.4212C11.8352 22.5246 12.1648 22.5246 12.4688 22.4212C13.8938 21.9478 21 19.1606 21 10.7597V5.25C21 4.85218 20.842 4.47064 20.5607 4.18934C20.2794 3.90804 19.8978 3.75 19.5 3.75ZM12 21C11.1319 20.7112 7.94156 19.47 6.01219 16.3594L12 12.165L17.9878 16.3566C16.0603 19.4634 12.8756 20.7047 12 21ZM19.5 10.7644C19.5 12.4181 19.185 13.8234 18.6825 15.015L12.4303 10.6387C12.3042 10.5504 12.154 10.503 12 10.503C11.846 10.503 11.6958 10.5504 11.5697 10.6387L5.3175 15.0122C4.815 13.8206 4.5 12.4153 4.5 10.7616V5.25H19.5V10.7644Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystal);
export default __webpack_public_path__ + "static/media/crystal.5ddd25420314ac893de50c2fbcc6482c.svg";
export { ForwardRef as ReactComponent };